import React from 'react'
import Layout from '@utils/layout'
import "@fontsource/assistant"

export const wrapPageElement = ({ element }) => <Layout>{element}</Layout>